<template>
  <section id="error-page" class="section-header">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6">
          <h2>Page Not Found</h2>
          <p>The page you're looking for is not found anywhere.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PageError404',
};
</script>

<style lang="scss" scoped>
 #error-page {
   padding-top: 15rem;
 }
</style>
